import { Title, Flex, Text, Button, Switch } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import classes from './userHeader.module.scss';
import { useConfirmDeleteModal } from '@widgets/user';
import dayjs from 'dayjs';
import { joinStringWithFallback } from '@shared/helpers';

type UserHeaderProps = {
  isMe?: boolean;
  isDelete?: boolean;
  createdAt?: string;
  id?: number | null;
  firstName?: string;
  lastName?: string;
  group?: string;
  company?: string;
  role?: string;
  absolutePath?: string;
  isShowActivity?: boolean;
  isActive?: boolean;
  handleChangeActivity?: () => void;
  isPendingChangeActivity?: boolean;
};

export const UserHeader = ({
  isMe = false,
  isDelete = true,
  createdAt = '',
  id = null,
  firstName = '',
  lastName = '',
  group = '',
  company = '',
  isShowActivity = false,
  isActive = false,
  handleChangeActivity = () => {},
  isPendingChangeActivity = false,
}: UserHeaderProps) => {
  const { openConfirmDeleteModal } = useConfirmDeleteModal();

  const handleDelete = () => {
    openConfirmDeleteModal(id?.toString() ?? '', firstName, lastName);
  };

  return (
    <Flex wrap='wrap' direction='column' gap={32}>
      <Flex align='center' w='100%' justify='space-between' wrap='wrap'>
        <Flex wrap='wrap' rowGap={16} columnGap={32} align='center'>
          <Flex gap={8}>
            <Text size='sm' c='tertiary.7'>
              ID:
            </Text>
            <Text size='sm'>{id}</Text>
          </Flex>

          <Flex gap={8}>
            <Text size='sm' c='tertiary.7'>
              Дата создания:
            </Text>
            <Text size='sm'>{dayjs(createdAt).format('DD.MM.YYYY')}</Text>
          </Flex>

          {isShowActivity && (
            <Flex gap={12} align='center'>
              <Text size='sm'>Активность:</Text>
              <Switch
                checked={isActive}
                onChange={handleChangeActivity}
                label={isActive ? 'Активен' : 'Неактивен'}
                disabled={isPendingChangeActivity}
              />
            </Flex>
          )}
        </Flex>

        {!isMe && isDelete && (
          <Button
            variant='subtle'
            size='sm'
            leftSection={<IconTrash size={20} />}
            className={classes.deleteButton}
            onClick={handleDelete}
          >
            Удалить сотрудника
          </Button>
        )}
      </Flex>

      <Flex gap={16} align='center'>
        <Flex direction='column' gap={4}>
          <Title c='primary.7' order={3}>
            {joinStringWithFallback([firstName, lastName], {
              separator: ', ',
              fallback: '-',
            })}
          </Title>
          <Text c='tertiary.7'>{`${group} ${company || ''}`}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
